import React from 'react';
import { Reveal } from './Reveal';
import { StarDivider } from './Ornaments';

// Gold constellation points on the plate (% of plate width/height)
const GLINTS = [
  { x: 75.7, y: 49.1, size: 1.7, dur: 14, delay: 2 },
  { x: 26.2, y: 14.7, size: 1.2, dur: 16, delay: 8.5 },
  { x: 75.7, y: 19.1, size: 1, dur: 15, delay: 12.5 },
];

const WingedSigil = ({ className = '' }) => (
  <svg viewBox="0 0 80 120" className={`world-sigil ${className}`} fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" aria-hidden>
    <path d="M40 14 C34 6 26 4 18 8 C26 10 31 15 34 22 C27 20 20 22 15 28 C23 27 30 30 35 36" />
    <path d="M40 14 C46 6 54 4 62 8 C54 10 49 15 46 22 C53 20 60 22 65 28 C57 27 50 30 45 36" />
    <path d="M40 10 V104" strokeWidth="0.8" />
    <path d="M36 40 L40 36 L44 40 L40 44 Z" fill="currentColor" stroke="none" />
    <circle cx="40" cy="108" r="2" fill="currentColor" stroke="none" />
  </svg>
);

const Glint = ({ x, y, size, dur, delay }) => (
  <svg viewBox="0 0 24 24" className="world-glint" style={{ left: `${x}%`, top: `${y}%`, '--tw-size': size, '--tw-dur': `${dur}s`, '--tw-delay': `${delay}s` }} aria-hidden>
    <path d="M12 0 C12.6 8 16 11.4 24 12 C16 12.6 12.6 16 12 24 C11.4 16 8 12.6 0 12 C8 11.4 11.4 8 12 0 Z" fill="#D9B86C" />
    <circle cx="12" cy="12" r="1.6" fill="#FFF6E0" />
  </svg>
);

const Closing = ({ className = '' }) => (
  <div className={className}>
    <p className="world-close" data-testid="world-closing">This is Ikarus.</p>
    <StarDivider className="world-rule mt-3" />
  </div>
);

export const WorldSection = () => (
  <section id="world" className="world" data-nav-theme="light" data-testid="world-section">
    <div className="world-dawn" aria-hidden />

    <Reveal className="world-plate-wrap">
      <img src="/realms/world-plate.webp" alt="Ikarus walking toward the celestial gate" className="world-plate" draggable="false" data-testid="world-plate" />
      <div className="world-halo" aria-hidden />
      <img src="/realms/world-bird.webp" alt="" className="world-bird" draggable="false" aria-hidden />
      {GLINTS.map((g) => <Glint key={`${g.x}-${g.y}`} {...g} />)}
    </Reveal>

    <div className="world-column" style={{ backgroundImage: "url('/realms/world-clouds.webp')" }} data-testid="world-column">
      <Reveal>
        <h2 className="world-eyebrow" data-testid="world-title">The World</h2>
        <StarDivider className="world-rule mt-3" />
      </Reveal>
      <Reveal delay={120}>
        <p className="world-statement" data-testid="world-statement">Humanity has always claimed encounters with the divine.</p>
      </Reveal>
      <Reveal delay={220}>
        <p className="world-statement world-statement--gold" data-testid="world-statement-gold">These artifacts are what remained.</p>
      </Reveal>
      <Reveal delay={320} className="flex justify-center">
        <WingedSigil />
      </Reveal>
      <Reveal delay={420} className="world-passage">
        <p>Across oceans and ages, stories were told of gods who walked, spoke, ruled, loved, and tested those who dared to witness them.</p>
        <p>Ikarus is the record of one such witness.<br />What you see here are not myths.<br />They are evidence.<br />Forged in precious materials.<br />Preserved in timeless craft.<br />Each piece an artifact from an encounter between the human and the divine.</p>
      </Reveal>
      <Reveal delay={520} className="hidden md:block">
        <Closing />
      </Reveal>
    </div>

    <Reveal className="world-plate-m-wrap md:hidden">
      <img src="/realms/world-plate-m.webp" alt="Ikarus walking toward the celestial gate" className="world-plate-m" draggable="false" />
    </Reveal>
    <Reveal className="md:hidden px-6 pt-8 pb-12 text-center">
      <Closing />
    </Reveal>
  </section>
);
